
(() => {
  const KEY = 'lunova-color-mode';
  const root = document.documentElement;

  function applyMode(mode, persist = false) {
    const selectedMode = mode === 'dark' ? 'dark' : 'light';
    const isDark = selectedMode === 'dark';

    root.setAttribute('data-theme-mode', selectedMode);
    root.setAttribute('data-lunova-mode', selectedMode);

    document.querySelectorAll('[data-theme-toggle], [data-lunova-mode-toggle]').forEach((button) => {
      const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
      const visibleLabel = button.querySelector('[data-lunova-mode-label]');
      if (visibleLabel) visibleLabel.textContent = label;
    });

    if (persist) {
      try {
        window.localStorage.setItem(KEY, selectedMode);
      } catch (error) {
        // The selected mode still applies for this page.
      }
    }
  }

  let savedMode = null;
  try {
    savedMode = window.localStorage.getItem(KEY);
  } catch (error) {
    // Keep the original light theme when browser storage is unavailable.
  }

  applyMode(savedMode);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-theme-toggle], [data-lunova-mode-toggle]');

    if (!button) return;

    const nextMode =
      root.getAttribute('data-theme-mode') === 'dark'
        ? 'light'
        : 'dark';

    applyMode(nextMode, true);
  });
})();
